import http from "infra/http";
import { useMutation } from "react-query";
import { VotacaoForm } from "../typings";

function useSaveAssembleia(id: string | null) {
  return useMutation(
    `/v1/votacao/${id ? id : ""}`,
    async (data: VotacaoForm) => {
      const form = { ...data };
      form.perguntas?.forEach((questao: any, index: number) => {
        questao.ordem = index;

        questao.opcoes?.forEach((opcao: any, i: number) => {
          opcao.ordem = i;
        });
      });

      const result = await http[id ? "put" : "post"](
        `/v1/votacao/${id ? id : ""}`,
        data
      );
      return result.data as {id: string};
    },
    { retry: false }

  );

}

export default useSaveAssembleia;
